<template>
    <div class="video" :style="videoStyle">
        <iframe
            :src="iframe"
            :width="w"
            :height="h"
            frameborder="0"
            autoplay="1"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
        ></iframe>
    </div>
</template>

<script>
export default {
    name: 'VideoLoop',
    props: ['hd', 'iframe'],
    computed: {
        videoStyle() {
            if (this.hd) {
                return {}
            } else {
                return {
                    top: '-70%',
                    left: '-70%',
                    width: '240%',
                    height: '240%',
                    zIndex: -200
                }
            }
        },
        w() { return this.hd ? '1920' : '' },
        h() { return this.hd ? '1080' : '' }
    }
}
</script>

<style lang="scss" scoped>
iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
}
.video {
    position: absolute;
    top: -30%;
    left: -30%;
    width: 160%;
    height: 160%;
    background-color: black;
}

@media (min-aspect-ratio: 16/9) {
    .video { height: 300%; top: -100%; }
}
@media (max-aspect-ratio: 16/9) {
    .video { width: 300%; left: -100%; }
}
@media all and (max-width: 600px) {
    .vid-info { width: 50%; padding: .5rem; }
    .vid-info h1 { margin-bottom: .2rem; }
}
@media all and (max-width: 500px) {
    .vid-info .acronym { display: none; }
}
</style>